import React from 'react'

function IconBoxDiamond14({ fill, stroke }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 1V9C13 11.2091 11.2091 13 9 13H1V5C1 2.79086 2.79086 1 5 1H13Z" fill={fill} />
      <path fillRule="evenodd" clipRule="evenodd" d="M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H13.5V9C13.5 11.4853 11.4853 13.5 9 13.5H0.5V5ZM5 1.5C3.06701 1.5 1.5 3.067 1.5 5V12.5H9C10.933 12.5 12.5 10.933 12.5 9V1.5H5ZM7 3.29289L10.7071 7L7 10.7071L3.29289 7L7 3.29289ZM4.70711 7L7 9.29289L9.29289 7L7 4.70711L4.70711 7Z" fill={stroke} />
    </svg>
  )
}

export default IconBoxDiamond14